import { getLang, getProtocol } from './utils'

const protocal = getProtocol();

export const API_HOST = `${protocal}wk-cgi.content.xunlei.com`  // 只有grabcode页面在用
export const GRAB_URL = API_HOST + '/wanke/?m=vceu0c9' 			// 只有grabcode页面在用
export const ZQB_HOST = 'http://zqb.red.xunlei.com' 			// 只有exchange页面在用

const lang = getLang();
const apiSuffix = lang === 'cn' ? '' : `-${lang}`;
export const ONECLOUD_API_HOST = `${protocal}api${apiSuffix}-content.onethingcloud.com/${window.LANG}`;

export const commonApi = {
    checklogin: `${ONECLOUD_API_HOST}/user/checklogin`,
    freshImgCode: `${ONECLOUD_API_HOST}/captcha/refresh`,
    // getconfig: `${ONECLOUD_API_HOST}/opensale/getconfig`,
    // commit: `${ONECLOUD_API_HOST}/opensale/commit`,
    usercouponlist: `${ONECLOUD_API_HOST}/coupon/userCouponList`,
    uploadImage: `${ONECLOUD_API_HOST}/upload/imagecontent`,
}



// WEBPACK FOOTER //
// ./js/src/common/consts.js